import { ReactComponent as GithubIcon } from 'assets/icons/github-mark-white.svg';
import { ReactComponent as CheckMark } from 'assets/icons/checkmark-24.svg';
import './style.scss';
import { v4 as uuidv4 } from 'uuid';
import { useAppSelector } from 'hooks/reduxHooks';
import { RootState } from 'redux-setup/store';
import { Path } from 'router/constant';
const GithubAuth = () => {
  const state = uuidv4();
  localStorage.setItem('github_login_state', state);
  const isGithubUser = useAppSelector(
    (state: RootState) => state.user.isGithubUser,
  );

  const handleRedirect = () => {
    const appID = process.env.REACT_APP_GITHUB_CLIENT_ID;
    const baseReliantUrl = process.env.REACT_APP_BASE_RELIANT_URL;

    window.open(
      `https://github.com/login/oauth/authorize?client_id=${appID}&state=${state}&redirect_uri=${baseReliantUrl}${Path.GITHUB_AUTH_LOADING}`,
    );
  };

  return (
    <div className="github-auth-container">
      <div className="github-auth-content">
        {!isGithubUser && (
          <div
            className="mt-10 github-icon flex justify-center gap-3 cursor-pointer text-white"
            onClick={handleRedirect}>
            <GithubIcon />
            Authenticate with GitHub
          </div>
        )}
        {isGithubUser && (
          <div className="mt-10 github-icon flex items-center logout_popup justify-center gap-3 text-white">
            <CheckMark />
            <GithubIcon />
            Authenticated with GitHub
          </div>
        )}
      </div>
    </div>
  );
};

export default GithubAuth;
